export default __webpack_public_path__ + "static/media/smart-spin-logo.579ec924.png";